import React, { Fragment } from "react";

class Calendar extends React.Component {
  state = {
    selectedYear: new Date().getFullYear(),
    selectedMonth: new Date().getMonth() + 1,
    animation: "",
    checkedDay: null
  };
  constructor(props) {
    super(props);
    this.currentMonth = new Date().getMonth() + 1;
    this.currentYear = new Date().getFullYear();
    this.currentDay = new Date().toString().slice(8, 10);
    this.selected = "";
    this.weekDayNames = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    this.months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
  }

  renderCalendar = (year, month) => {
    const monthLength = new Date(year, month, 0).getDate() + 1; // this will return total days in a month
    var weekDay = 0; // starting sunday
    const arr = [];
    const arrPrev = [];
    const arrNext = [];
    var finalArr = [];

    for (let i = 1; i < monthLength; i++) {
      const dayOfCalendarRef = React.createRef();
      var dateFormat = new Date(year, month - 1, i).toString(); // this will return the day current iteration in date format
      var weekDayName = new Date(year, month - 1, i).toString().slice(0, 2); // this will return the day name of current iteration
      arr.push({
        day: i,
        dayName: weekDayName,
        dateFormat,
        action: "none",
        ref: dayOfCalendarRef
      });

      if (weekDay < 6) {
        weekDay++;
      } else {
        weekDay = 0;
      }
    }

    if (arr[0].dayName !== "Su") {
      var prevMonthLength = 0;
      // eslint-disable-next-line
      var prevMonth = 0;
      const length = this.weekDayNames.indexOf(arr[0].dayName);

      if (month > 1) {
        prevMonth = month - 1;
        prevMonthLength = new Date(year, month - 1, 0).getDate() + 1; // this will return total days in previous month
      } else {
        prevMonth = 12;
        prevMonthLength = new Date(year, 10, 0).getDate() + 1; // this will return total days in previous month
      }

      for (let i = 0; i < length; i++) {
        const dayOfCalendarRef = React.createRef();
        arrPrev.push({
          day: prevMonthLength - i - 1,
          action: "remove",
          ref: dayOfCalendarRef
        });
      }
    }

    if (arr[arr.length - 1].dayName !== "Sa") {
      const length = 6 - this.weekDayNames.indexOf(arr[arr.length - 1].dayName);
      for (let i = 0; i < length; i++) {
        const dayOfCalendarRef = React.createRef();
        arrNext.push({
          day: i + 1,
          action: "add",
          ref: dayOfCalendarRef
        });
      }
    }
    finalArr = arrPrev
      .reverse()
      .concat(arr)
      .concat(arrNext);

    return finalArr.map((day, index) => {
      return (
        <Fragment key={index}>
          <input
            id={`input-${index}`}
            type="radio"
            name="calendar"
            className={"input-day"}
            value={!day.dateFormat ? day.day : day.dateFormat}
            onChange={e => this.oncheck(day.day)} // to control the input
            onClick={
              day.action !== "none"
                ? day.action === "add"
                  ? e => this.modifyDate("add")
                  : e => this.modifyDate("remove")
                : null
            }
            ref={day.ref}
            checked={
              // eslint-disable-next-line
              day.dateFormat && this.state.checkedDay == day.day ? true : false
            } // controlled input
          />

          <label
            htmlFor={`input-${index}`}
            className={`day ${day.action !== "none" ? "grayed" : null} ${
              // eslint-disable-next-line
              this.currentDay == day.day &&
              this.currentMonth === month &&
              this.currentYear === year
                ? "today"
                : null
            }`}
          >
            <p>{day.day}</p>
          </label>
        </Fragment>
      );
    });
  };

  oncheck = day => {
    this.setState({ checkedDay: day });
    setTimeout(() => {
      this.props.getDate(
        new Date(this.state.selectedYear, this.state.selectedMonth - 1, day),
        this.props.calendarRef
      );
    }, 0);
  };

  modifyDate = param => {
    this.setState({ checkedDay: null });
    setTimeout(() => {
      switch (param) {
        case "add":
          this.setState({ animation: "next" });
          if (this.state.selectedMonth === 12) {
            this.setState({ selectedMonth: 1 });
            this.setState({ selectedYear: this.state.selectedYear + 1 });
          } else {
            this.setState({ selectedMonth: this.state.selectedMonth + 1 });
          }
          break;
        case "remove":
          this.setState({ animation: "prev" });
          if (this.state.selectedMonth === 1) {
            this.setState({ selectedMonth: 12 });
            this.setState({ selectedYear: this.state.selectedYear - 1 });
          } else {
            this.setState({ selectedMonth: this.state.selectedMonth - 1 });
          }
          break;
        case "up":
          this.setState({ animation: "next" });
          this.setState({ selectedYear: this.state.selectedYear + 1 });
          break;
        case "down":
          this.setState({ animation: "prev" });
          this.setState({ selectedYear: this.state.selectedYear - 1 });
          break;

        default:
          break;
      }
    }, 0);
    // this.setState({ animation: "prev" });
    this.setState({ animation: "center" });
  };

  renderDayNames = () => {
    return this.weekDayNames.map(nam => {
      return (
        <div
          key={nam}
          // style={{
          //   width: "calc(100% / 7)",
          //   padding: "5px 0",
          //   justifyContent: "center",
          //   display: "flex"
          // }}
        >
          {nam}
        </div>
      );
    });
  };

  blurDayOfCalendar = (e, ref) => {
    ref.current.checked = false;
  };

  render() {
    return (
      <Fragment>
        <div className="gd-calendar-container">
          <div className="date-selector">
            <button className="button" onClick={e => this.modifyDate("remove")}>
              <i className="material-icons">keyboard_arrow_left</i>
            </button>
            <div className="monthName">
              {this.months[this.state.selectedMonth - 1]}
            </div>
            <div className="year">
              <i
                className="material-icons"
                onClick={e => this.modifyDate("up")}
              >
                keyboard_arrow_left
              </i>
              {this.state.selectedYear}
              <i
                className="material-icons"
                onClick={e => this.modifyDate("down")}
              >
                keyboard_arrow_right
              </i>
            </div>
            <button className="button" onClick={e => this.modifyDate("add")}>
              <i className="material-icons">keyboard_arrow_right</i>
            </button>
          </div>
          <div className="calendar">
            <div className="cal-title">{this.renderDayNames()}</div>
            <div className={`cal-body ${this.state.animation}`}>
              {this.renderCalendar(
                this.state.selectedYear,
                this.state.selectedMonth
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default Calendar;
